import { render, staticRenderFns } from "./StudyStatistics.vue?vue&type=template&id=6700cb66&scoped=true&"
import script from "./StudyStatistics.vue?vue&type=script&lang=js&"
export * from "./StudyStatistics.vue?vue&type=script&lang=js&"
import style0 from "./StudyStatistics.vue?vue&type=style&index=0&id=6700cb66&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6700cb66",
  null
  
)

export default component.exports